/**
 * Tab State Management
 * Manages tab state, history, and event tracking
 */

class TabStateManager {
    constructor() {
        this.activeTabs = new Map();
        this.tabHistory = [];
        this.tabEvents = new Map();
        this.previousActiveTabId = null;
    }
    
    /**
     * Register a tab
     */
    registerTab(tabId, tabData) {
        this.activeTabs.set(tabId, {
            ...tabData,
            isActive: tabData.isActive || false
        });
    }
    
    /**
     * Update tab active state
     */
    updateTabState(tabId, updates) {
        const tabData = this.activeTabs.get(tabId);
        if (tabData) {
            Object.assign(tabData, updates);
        }
    }
    
    /**
     * Get tab data
     */
    getTab(tabId) {
        return this.activeTabs.get(tabId);
    }
    
    /**
     * Add to history
     */
    addToHistory(tabId, tabLink) {
        try {
            this.tabHistory.push({
                tabId,
                tabLink,
                timestamp: Date.now()
            });
            
            // Keep history limited
            if (this.tabHistory.length > 50) {
                this.tabHistory.shift();
            }
        } catch (error) {
            if (debugMode === '1') {
                console.error('[TabStateManager] Add to history error:', error);
            }
        }
    }
    
    /**
     * Store tab event
     */
    storeEvent(eventName, data) {
        this.tabEvents.set(`${eventName}-${Date.now()}`, data);
    }
    
    /**
     * Get tab statistics
     */
    getStats() {
        return {
            totalTabs: this.activeTabs.size,
            activeTabs: Array.from(this.activeTabs.entries()).filter(([_, data]) => data.isActive),
            historySize: this.tabHistory.length,
            recentEvents: Array.from(this.tabEvents.keys()).slice(-10)
        };
    }
    
    /**
     * Set previous active tab ID
     */
    setPreviousActiveTabId(tabId) {
        this.previousActiveTabId = tabId;
    }
    
    /**
     * Get previous active tab ID
     */
    getPreviousActiveTabId() {
        return this.previousActiveTabId;
    }
}

export { TabStateManager };

